<template>
  <div
    id="app"
    :class="{ 'language-ch': language == 'ch' || language == 'en' }"
  >
    <!--头部-->
    <app-header :language="language"></app-header>

    <!--中间内容区-->
    <!-- popwindow -->
    <transition name="fade">
      <div class="overlay" v-show="isShow">
        <span v-on:click="closeVideo">×</span>
        <video
          id="myvideo"
          :src="videoUrl"
          controls
          webkit-playsinline="true"
          playsinline="true"
        >
          您的浏览器不支持 video 视屏播放。
        </video>
      </div>
    </transition>
    <div class="page-container">
      <router-view
        :language="language"
        ref="currentPage"
        @isPlay="playVideoFn"
      ></router-view>
    </div>

    <!--尾部-->
    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
import AppFooter from "./components/Footer.vue";
import AppHeader from "./components/Header.vue";
import videoInit from "./assets/about/videoInit.png";
export default {
  name: "app",
  data() {
    return {
      language: this.getLanguage(),
      isShow: false,
      videoUrl: "https://minio.oceanbluecloud.com/redio/mov.mp4",
      videoInit: videoInit,
    };
  },
  components: {
    AppFooter,
    AppHeader,
  },
  mounted() {
    this.is_iPad();
  },
  methods: {
    scrollChange() {
      this.baseHeight =
        (document.body.scrollTop || window.pageYOffset) +
        window.innerHeight -
        this.headHeight;
      if (typeof this.$refs.currentPage.upAnimation == "function") {
        this.$refs.currentPage.upAnimation(this.baseHeight);
      }
    },
    getLanguage() {
      localStorage.language =
        ["ch", "en"].indexOf(localStorage.language) > -1
          ? localStorage.language
          : navigator.language == "zh-CN"
          ? "ch"
          : "en";
      this.$parent._i18n.locale = localStorage.language;
      return localStorage.language;
    },
    // video
    closeVideo() {
      this._dom = document.getElementById("myvideo");
      this._dom.pause();
      this.isShow = false;
      // location.reload();
    },
    playVideoFn(data) {
      if (data == "play") {
        this.isShow = true;
        this._dom = document.getElementById("myvideo");
        this._dom.play();
      }
    },
    is_iPad() {
      if (navigator.userAgent.match(/(pad|pod|iPod|iPad Phone)/i)) {
        this.videoUrl = "https://minio.oceanbluecloud.com/redio/webMov.mp4";
      }
    },
  },
};
</script>

<style lang="scss">
@function toRem($x) {
  @return $x / 37.5 * 1rem;
}
@font-face {
  font-family: "Avenir Book";
  src: url("~assets/fonts/586b6cfb55bdabefa139f8caa6f96be3.ttf");
  font-weight: normal;
  font-style: normal;
  src: url("~assets/fonts/5dc3c406d84926ed82540f7fb6d70c72.eot");
  src: url("~assets/fonts/5dc3c406d84926ed82540f7fb6d70c72.eot#iefix")
      format("embedded-opentype"),
    url("~assets/fonts/586b6cfb55bdabefa139f8caa6f96be3.ttf") format("truetype"),
    url("~assets/fonts/4922cebc3f76e902e96e1c3c4aafa96b.woff") format("woff"),
    url("~assets/fonts/f2867aef31c1248dc3041c93ebae39dc.svg#obc-fonts")
      format("svg");
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html {
  font-family: "Avenir Book", PingFangSC-Regular, "Microsoft YaHei",
    HelveticaNeue, Helvetica, Arial, sans-serif;
  font-size: 14px;
}
/*样式重置*/
body,
h1,
h2,
h3,
h4,
h5,
p,
dl,
dd,
ul,
form,
input,
textarea,
th,
td,
select {
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5 {
  font-weight: normal;
}

em {
  font-style: normal;
}

li {
  list-style: none;
}

img {
  border: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

textarea {
  resize: none;
  overflow: auto;
}

select,
input,
textarea,
option,
a,
button {
  outline: none !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
  tap-highlight-color: rgba(0, 0, 0, 0) !important;
}

* {
  box-sizing: border-box;
}

/*public*/
.clear {
  zoom: 1;
}

.clear:after {
  content: "";
  display: block;
  clear: both;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

a {
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}

a:hover {
  cursor: pointer;
  color: #fff;
}

.hide {
  display: none;
}

.show {
  display: block;
}
/*高度与头部耦合*/
#app .page-container {
  padding-top: 50px;
}

/* popwindow */
.overlay,
.overlay * {
  margin: 0;
  padding: 0;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
}
.overlay > .content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%); /* IE 9 */
  -moz-transform: translate(-50%, -50%); /* Firefox */
  -webkit-transform: translate(-50%, -50%); /* Safari 和 Chrome */
  -o-transform: translate(-50%, -50%); /* Opera */
  background-color: #000;
  border-radius: toRem(5);
  overflow: hidden;
}
.overlay span {
  color: #fff;
  width: toRem(30);
  height: toRem(30);
  font-size: toRem(25);
  border-radius: toRem(15);
  line-height: toRem(25);
  text-align: center;
  cursor: pointer;
  position: absolute;
  right: toRem(10);
  top: toRem(60);
  border: toRem(1) solid #fff;
  z-index: 100;
}
.overlay video {
  height: toRem(240);
  width: toRem(300);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%); /* IE 9 */
  -moz-transform: translate(-50%, -50%); /* Firefox */
  -webkit-transform: translate(-50%, -50%); /* Safari 和 Chrome */
  -o-transform: translate(-50%, -50%); /* Opera */
}
.overlayr .content > span:hover {
  box-shadow: 0 0 toRem(3) toRem(1) #ccc;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.8s ease;
}
.fade-leave-to {
  opacity: 0;
}
.device h1,
.device h3,
.device .device-img,
.device .infor {
  -webkit-transition: all 0.8s;
  -moz-transition: all 0.8s;
  transition: all 0.8s;
  -webkit-transform: translate3d(0, 50px, 0);
  -moz-transform: translate3d(0, 50px, 0);
  transform: translate3d(0, 50px, 0);
  opacity: 0;
}
.device.is-visible h1,
.device.is-visible h3,
.device.is-visible .device-img,
.device.is-visible .infor {
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// App.vue?09a6e215